/*
| The colours suggested for shift presets: a new preset starts on one
| (STG-WEB-14) and the colour select offers them (STG-WEB-15). Eleven hues a step
| apart on the colour wheel plus a neutral, at a depth that stays readable
| with white text on the calendar and tells presets apart at a glance. Any
| other colour can still be picked as a custom one.
*/
export const PRESET_PALETTE = [
  { name: 'Red', hex: '#DC2626' },
  { name: 'Orange', hex: '#EA580C' },
  { name: 'Amber', hex: '#D97706' },
  { name: 'Lime', hex: '#65A30D' },
  { name: 'Green', hex: '#16A34A' },
  { name: 'Teal', hex: '#0D9488' },
  { name: 'Cyan', hex: '#0891B2' },
  { name: 'Blue', hex: '#2563EB' },
  { name: 'Indigo', hex: '#4F46E5' },
  { name: 'Violet', hex: '#7C3AED' },
  { name: 'Pink', hex: '#DB2777' },
  { name: 'Slate', hex: '#475569' },
] as const

/** The first suggested colour no preset uses yet, so new presets differ by default */
export function nextPaletteColor(usedHexes: string[]): string {
  const used = new Set(usedHexes.map((hex) => hex.toUpperCase()))

  return (PRESET_PALETTE.find((color) => !used.has(color.hex)) ?? PRESET_PALETTE[0]).hex
}
